<template>
  <div class="user-custom-signature" :class="{'show-header' : !hideHeader}">
    <div class="header-section" v-if="!hideHeader">{{ pageTitle }}</div>
    <div class="body-section">
      <div class="info-message" v-if="loadingConfig || !editorLoaded || !smsEditorLoaded">
        <i class="fa fa-spinner fa-spin mr-1"></i>Loading..
      </div>
      <div class="info-message" v-else-if="!userId">
        <i class="fa fa-exclamation-triangle mr-1"></i>User info not provided
      </div>
      <template>
        <div class="signature-container" v-show="editorLoaded && smsEditorLoaded">

          <div class="sms-signature-wrapper">
            <div class="font-weight-500">SMS Signature</div>
            <textarea id="smsSignatureContent"></textarea>
          </div>
          <div class="email-signature-wrapper">
            <div class="font-weight-500">Email Signature</div>
            <textarea id="emailSignatureContent"></textarea>
          </div>
        </div>
      </template>
    </div>
    <div class="footer-section">
      <button class="btn btn-sm mr-0" @click="saveSignatures">Save</button>
    </div>
  </div>
</template>

<script>
import Sanitizer from "@/lib/utilities/helpers/sanitize.js";

export default {
  name: "userCustomSignature",
  props: ["user"],
  computed: {
    // ...mapGetters(["User"]),
    userId() {
      if (this.$route && this.$route.query && this.$route.query.userId)
        return this.$route.query.userId;

      return this.user.UserId;
    },
    hideHeader() {
      if (this.user) return true; //opening im the modal
      else
        return (
          this.$route &&
          this.$route.query &&
          this.$route.query.header == "false"
        );
    },
    pageTitle() {
      if (this.userInfo && this.userInfo.UserId)
        return `Manage User Signatures for ${this.userInfo.Name}`;
      return `Manage User Signatures`;
    },
  },
  watch: {
    editorLoaded() {
      if (this.editorLoaded) {
        tinymce.get("emailSignatureContent").setContent(this.email_signature);
      } else this.loadEmailEditor();
    },
    smsEditorLoaded() {
      if (this.smsEditorLoaded) {
        tinymce
          .get("smsSignatureContent")
          .setContent((this.sms_signature || "").replaceAll("\n", "<br/>"));
      } else this.loadSMSEditor();
    },
  },
  data() {
    return {
      userInfo: null,
      errorMessages: [],
      loadingConfig: false,
      editorLoaded: false,
      smsEditorLoaded: false,
      email_signature: "",
      sms_signature: "",
      savedCustomSignature: null,
    };
  },
  created() {
    this.getUserInfo();
    this.getCustomSignatures();
    // this.loadEmailEditor();
    // this.loadSMSEditor();
  },
  beforeDestroy() {
    tinymce.remove("#emailSignatureContent");
    tinymce.execCommand("mceRemoveControl", true, "emailSignatureContent");

    tinymce.remove("#smsSignatureContent");
    tinymce.execCommand("mceRemoveControl", true, "smsSignatureContent");

    if (tinymce.EditorManager && tinymce.EditorManager.editors)
      tinymce.EditorManager.editors = [];
  },
  methods: {
    async getUserInfo() {
      if (this.user) {
        this.userInfo = this.user;
        return;
      }

      if (!this.userId) return;

      const response = await this.$store.dispatch("getUserInfo", this.userId);
      this.userInfo =
        response && response.data && response.data.Success
          ? response.data.Data
          : null;
    },
    loadSMSEditor() {
      setTimeout(() => {
        tinymce.remove("#smsSignatureContent");
        tinymce.init({
          selector: "#smsSignatureContent",
          height: "200px", //"100vh",
          promotion: false,
          deprecation_warnings: false,
          branding: true,
          wordcount: true,
          skin: "oxide",
          forced_root_block: "div",
          mode: "design", // textareas - previous value
          menubar: false,
          toolbar: false,
          contextmenu: "spellchecker",
          browser_spellcheck: true,
          format_empty_lines: false,
          pad_empty_with_br: false,
          default_font_stack: ["Arial"],
          content_style: "body { font-size: 12pt; font-family: Arial; }",
          init_instance_callback: () => {
            this.smsEditorLoaded = true;
          },
        });
      }, 500);
    },
    loadEmailEditor() {
      tinymce.remove("#emailSignatureContent");
       const maxFileSize = 10 * 1024 * 1024;
       let vm = this;

      setTimeout(() => {
        try {
          tinymce.remove("#emailSignatureContent");
        } catch (err) {
          console.log("Error clearing previous tiny editor: ", err);
        }
        tinymce.init({
          selector: "#emailSignatureContent",
          height: "450px", //"100vh",
          promotion: false,
          deprecation_warnings: false,
          branding: true,
          wordcount: true,
          skin: "oxide",
          forced_root_block: "div",
          mode: "design",
          contextmenu: "spellchecker",
          browser_spellcheck: true,
          keep_styles: true,
          format_empty_lines: true,
          pad_empty_with_br: true,
          toolbar_mode: "wrap",
          plugins: ["image", "fullscreen", "link", "lists", "table"],
          menubar: "edit view insert format tools",
          toolbar:
            "undo redo | fontsize fontfamily | forecolor backcolor bold italic underline | numlist bullist indent outdent lineheight   | link unlink | charmap code | headings | image imagetools emoticons ",
          fontsize_formats:
            "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 30pt 32pt 34pt 36pt",
          font_formats:
            "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva;",
          default_font_stack: ["Arial"],
          content_style: "body { font-size: 12pt; font-family: Arial; }",
          init_instance_callback: () => {
            this.editorLoaded = true;
          },
          images_upload_handler: function (
            blobInfo,
            success,
            failure,
            progress
          ) {
            if (blobInfo.blob().size > maxFileSize) {
              //failure("Image size cannot exceed more than 10MB", "Error");
              tinymce.activeEditor.undoManager.undo();
              vm.$snotify.error(
                "Image size cannot exceed more than 10MB",
                "Error"
              );
              return new Promise((resolve, reject) => {
                reject("Image size cannot exceed more than 10MB");
              });
            } else if (
              blobInfo.blob().type != "image/jpg" &&
              blobInfo.blob().type != "image/jpeg" &&
              blobInfo.blob().type != "image/png"
            ) {
              tinymce.activeEditor.undoManager.undo();
              vm.$snotify.error("Unsupported image type", "Error");
              return new Promise((resolve, reject) => {
                reject("Unsupported file type");
              });
            } else {
              let fileName = blobInfo.blob().name;
              let formData = new FormData();
              formData.append("file", blobInfo.blob(), fileName);

              let request = {
                AccountID: vm.userInfo.AccountID,
                AccountPlatformID: vm.userInfo.AccountPlatformID,
                FileContent: formData,
              };
              return vm.$store.dispatch("uploadTinyMCEImages", request);
            }
          },
        }),
          500;
      });
    },
    async getCustomSignatures() {
      this.loadingConfig = true;
      let id = this.user ? this.user.Id : this.userId;
      let response = await this.$store.dispatch("getUserSignatureSettings", id);
      if (response) {
        this.savedCustomSignature = response;
        this.sms_signature = response.CustomSignatureSms;
        this.email_signature = response.CustomSignatureEmail;
      } else {
        let eSignature = `<div>${this.userInfo.Name}</div>
            <div>${this.userInfo.Position ? this.userInfo.Position : ""}</div>
            <div>${
              this.userInfo.WorkNumber
                ? this.userInfo.WorkNumber
                : this.userInfo.MobileNumber
                ? this.userInfo.MobileNumber
                : ""
            }</div>
            <div>${this.userInfo.Email ? this.userInfo.Email : ""}</div>`;

        let sSignature = `${this.userInfo.Name}
            ${this.userInfo.Position ? this.userInfo.Position : ""}
            ${
              this.userInfo.WorkNumber
                ? this.userInfo.WorkNumber
                : this.userInfo.MobileNumber
                ? this.userInfo.MobileNumber
                : ""
            }
            ${this.userInfo.Email ? this.userInfo.Email : ""}`;

        this.sms_signature = sSignature;
        this.email_signature = eSignature;
      }
      this.loadEmailEditor();
      this.loadSMSEditor();

      // if (this.editorLoaded)
      //   tinymce.get("emailSignatureContent").setContent(eSignature);

      // if (this.smsEditorLoaded)
      //   tinymce.get("smsSignatureContent").setContent(sSignature);
      this.loadingConfig = false;
    },
    async saveSignatures() {
      let data = this.getSavableContent();

      if (data.sms.includes("f&amp;i"))
        data.sms = data.sms.replaceAll("f&amp;i", "f&i");

      if (data.email.includes("f&amp;i"))
        data.email = data.email.replaceAll("f&amp;i", "f&i");

      if (this.savedCustomSignature && this.savedCustomSignature.Id > 0) {
        this.savedCustomSignature.CustomSignatureEmail = data.email;
        this.savedCustomSignature.CustomSignatureSms = data.sms;
      } else {
        this.savedCustomSignature = {
          Userid: this.user ? this.user.Id : this.userId,
          CustomSignatureEmail: data.email,
          CustomSignatureSms: data.sms,
        };
      }

      let response = await this.$store.dispatch(
        "saveUserSignatureSettings",
        this.savedCustomSignature
      );
      if (response) {
        this.$snotify.success(
          "Signature settings updated successfully",
          "Success"
        );
        this.$emit("closeSignatureModal");
      } else {
        this.$snotify.error(
          "Something went wrong. Please try again later",
          "Error"
        );
        this.$emit("closeSignatureModal");
      }
    },
    getSavableContent: function () {
      let email_data = tinymce
        .get("emailSignatureContent")
        .getContent({ format: "raw" });

      let sms_data = tinymce
        .get("smsSignatureContent")
        .getContent({ format: "text" });
      sms_data = this.replaceSpanTokensWithSimpleTokens(sms_data);

      return {
        email: Sanitizer.sanitizeHtmlContent(email_data),
        sms: Sanitizer.sanitizeHtmlContent(sms_data),
      };
    },
    replaceSpanTokensWithSimpleTokens(contentHtml) {
      let data = JSON.parse(JSON.stringify(contentHtml || ""));
      const regexmatch = /<span.class="aa-token"(.*?)<\/span>/g;
      const matches = [...data.matchAll(regexmatch)];

      if ((matches || []).length > 0) {
        matches.forEach((value) => {
          let val = value[0].match(/{{.*}}/);
          if (val) {
            // TODO: Replace with empty string if token isnt found
            let tokenValue = val[0];
            data = data.replace(value[0], tokenValue);
          }
        });
      }
      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-custom-signature {
  width: 100%;
  height: 100%;
  text-align: left;

  &.show-header {
    .body-section {
      height: calc(100% - 60px - 60px);
    }
  }

  .header-section {
    height: 60px;
    overflow: hidden;
    padding: 15px;
    font-size: 18px;
    line-height: 30px;
    font-weight: 500;
    border-bottom: 1px solid $gray-lt;
  }

  .body-section {
    height: calc(100% - 60px);
    overflow-y: auto;
    padding: 15px;

    .signature-container {
      height: 100%;
      .sms-signature-wrapper {
        padding-bottom: 10px;

        .sms-text-area {
          line-height: 20px;
        }
      }

      .email-signature-wrapper {
        padding-top: 10px;
        //max-height: 400px;
      }
    }

    .info-message {
      padding-bottom: 15px;
      font-size: 16px;
      line-height: 30px;
    }

    .alert {
      max-width: 1000px;
      margin: 0px auto;
      margin-bottom: 15px;
    }
  }

  .footer-section {
    height: 60px;
    width: 100%;
    border-top: 1px solid $gray-lt;
    padding: 15px;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Users/UserCustomSignature.vue